import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { isMobile } from 'react-device-detect'

import { FormattedMessage, injectIntl } from 'react-intl'
import { Divider, Radio } from 'core/components/ui'
import { greys, font } from 'assets/themes/theme-default'
import { tradeInShape } from '../../shapes'

const PaintList = styled.div`
  ${isMobile ? ' max-height: 247px;' : ' height: 247px;'}
  overflow: hidden auto;
  &&& {
    .ant-radio-wrapper,
    .ant-radio-group {
      display: block;
    }
    .ant-radio-group {
      padding: 0 12px 0 0;
    }
    .ant-radio-wrapper {
      white-space: inherit;
      text-indent: -40px;
      padding-left: 40px;
      font-size: ${font.size.base};
    }
  }
`
const DividerStyled = styled(Divider)`
  margin: 12px 0;
  height: 1px;
  background-color: ${greys.light1};
`

const Paint = props => {
  const { tradeIn, setTradeIn, intl } = props
  const { filtersList, vehicle } = tradeIn
  const { designList } = filtersList
  const { exterior } = designList
  const { type } = exterior
  const handleChangePaint = id => {
    const { colors } = vehicle
    let newType = !type ? null : designList.exterior.type.find(el => el.id === id)

    if (!type && !_.isEmpty(vehicle.painting)) newType = { equipment: vehicle.painting.equipment }

    const extendedColors = {
      ...colors,
      type: newType || {
        equipment: intl.formatMessage({ id: 'standard_painting' })
      }
    }
    let extendedVehicle = vehicle

    extendedVehicle = {
      ...vehicle,
      colors: extendedColors
    }

    setTradeIn({
      ...tradeIn,
      vehicle: extendedVehicle
    })
  }

  const renderRadioList = item => (
    <React.Fragment key={item.id}>
      <Radio value={item.id}>{item.label}</Radio>
      <DividerStyled />
    </React.Fragment>
  )

  const renderInterior = () => {
    const typeSelected = vehicle.colors.type && vehicle.colors.type.id
    const serialPaints = type.filter(x => x.serial)
    const renderList = dataSource => (
      <PaintList className="scroll-bar">
        <Radio.Group
          buttonStyle="solid"
          value={typeSelected || 'default'}
          onChange={e => handleChangePaint(e.target.value)}
        >
          {!_.isEmpty(vehicle.painting) && (
            <>
              <Radio value="default">{vehicle.painting.equipment}</Radio>
              <DividerStyled />
            </>
          )}
          {serialPaints.length !== 1 && _.isEmpty(vehicle.painting) && (
            <>
              <Radio value="default">
                <FormattedMessage id="standard_painting" />
              </Radio>
              <DividerStyled />
            </>
          )}
          {dataSource.map(item => renderRadioList(item))}
        </Radio.Group>
      </PaintList>
    )

    return (
      <>
        <div>{type.length > 0 && renderList(type)}</div>
      </>
    )
  }

  return <>{renderInterior()}</>
}

Paint.propTypes = {
  intl: PropTypes.shape().isRequired,
  setTradeIn: PropTypes.func.isRequired,
  tradeIn: tradeInShape.isRequired,
  loading: PropTypes.bool.isRequired
}

export default injectIntl(Paint)
